/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [

    {
      url: "/",
      name: "خانه",
      slug: "Home",
      icon: "HomeIcon",
    },
    {
      url: "/users",
      name: "مدیریت کاربران",
      slug: "Users",
      icon: "UsersIcon",
    },
    {
      url: "/orders",
      name: "مدیریت سفارشات",
      slug: "Orders",
      icon: "ListIcon",
    },
    {
      url: "/factors",
      name: "مدیریت فاکتور ها",
      slug: "",
      icon: "LayersIcon",
    },
    {
      url: "/warranties",
      name: "گارانتی",
      slug: "",
      icon: "AwardIcon",
    },
    {
      url: "/posts",
      name: "مدیریت پست ها",
      slug: "",
      icon: "SmileIcon",
    },
    {
      url: "/editProfile",
      name: "ویرایش پروفایل",
      slug: "EditProfile",
      icon: "UserIcon",
    },
    {
      url: "https://app.raychat.io/",
      name: "ورود به رایچت",
      slug: "external",
      icon: "MessageCircleIcon",
      target: "_blank"
    },
]
